<template>
  <v-layout row wrap grid-list-lg>
    <v-flex xs12>
      <file-input v-if="!urlInput" :conversionType="conversionType"></file-input>
      <url-input v-if="urlInput" :conversionType="conversionType"></url-input>
    </v-flex>

    <conversion-results></conversion-results>

  </v-layout>
</template>

<script>
  import FileInput from '@/components/converter/input/GeoConverterFile';
  import URLInput from '@/components/converter/input/GeoConverterURL';
  import GeoResults from '@/components/converter/output/ConversionResults';

  export default {
    name: 'geo-converter',
    props: {
      urlInput: {
        required: true,
        type: Boolean,
      },
      conversionType: {
        required: true,
        type: String,
      },
    },
    components: {
      'file-input': FileInput,
      'url-input': URLInput,
      'conversion-results': GeoResults,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GeoConverter.vue